<template>
  <div class="PlannedRealisation">
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :validation="validation"
      :layout="layout"
      :disabled="disabled"
      :path="path"
    />
  </div>
</template>

<script>
import FieldSet from '@/components/form/FieldSet'

// import { required } from 'vuelidate/lib/validators'

export default {
  name: 'PlannedRealisation',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'PlannedRealisation',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Copied from Cafienne
      fields: {
        'PlannedDate': {
          'type': 'string',
          'title': 'Geplande realisatiedatum',
          'format': 'date',
        },
      },
      layout: [{
        'columns': '1fr',
        'fields': ['PlannedDate'],
      }],
      validation: {},
    }
  },
}
</script>
